<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import 'babel-polyfill'
export default {
  name: 'App'
}
</script>

<style>
body{
  padding: 0;
  margin: 0;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  /* width: 1200px; */
  /* margin: auto; */
  font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
  background-color: #E5E8E8;
}
</style>



// WEBPACK FOOTER //
// src/App.vue